import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ProductService } from '../services/product.service';
import { ProductV2Dto } from '../interfaces/product-interface';

@Injectable({
  providedIn: 'root',
})
export class ProductsV2Resolver {
  constructor(private productService: ProductService) {}

  resolve(): Observable<ProductV2Dto[]> {
    return this.productService.getProductsV2();
  }
}
